import { InputAdornment, TextField, Typography } from "@mui/material";
import * as React from "react";
import { FormField } from "ui/Scripts/source/components/framework/FormField";
import { Base } from "ui/Scripts/source/framework/base";
import { ITaskDataRowCol, TaskDataRowCol } from "ui/Scripts/source/models/task/taskDataRowCol";
import { ITaskTypeCol } from "ui/Scripts/source/models/task/taskTypeCol";
import { FormFieldMargin } from "./TaskDynamicForm.styles";
import { DisabledInputClickEnabler } from "./DisabledInputClickEnabler";
import { getFormFieldTitleColor, getFormFieldTitle } from "./TaskDynamicFormFieldUtils";

export interface ITaskDynamicFormNumberProp {
    isReadOnly: boolean;
    colIsReadOnly: boolean;
    showFieldName: boolean;
    showFieldNameColor: string;
    taskTypeCol: ITaskTypeCol;
    taskDataRowCol: ITaskDataRowCol;
    onChange: (dataCol: ITaskDataRowCol) => void;
}

export class TaskDynamicFormNumber extends React.Component<ITaskDynamicFormNumberProp, {}> {
    handleChange = (event) => {
        const props = this.props;
        const typeCol = props.taskTypeCol;
        const target = event.target;
        const strValue: string = Base.filterDecimalStr(target.value, typeCol.minimum, typeCol.maximum, typeCol.decimals);
        const newValue = new TaskDataRowCol(props.taskDataRowCol);
        if (!typeCol.required && Base.isNullOrEmpty(strValue)) {
            newValue.valueStr = "";
            newValue.valueNbr = null;
            this.props.onChange(newValue);
            return;
        }
        newValue.valueStr = strValue;
        newValue.valueNbr = !Base.isNullOrEmpty(strValue) ? Base.strToNumber(strValue, typeCol.minimum, typeCol.maximum) : 0;
        props.onChange(newValue);
    };

    handleBlur = (event) => {
        const props = this.props;
        const typeCol = props.taskTypeCol;
        const target = event.target;
        const strValue: string = target.value;
        const newValue = new TaskDataRowCol(props.taskDataRowCol);
        if (!typeCol.required && Base.isNullOrEmpty(strValue)) {
            newValue.valueStr = "";
            newValue.valueNbr = null;
            this.props.onChange(newValue);
            return;
        }
        newValue.valueNbr = !Base.isNullOrEmpty(strValue) ? Base.strToNumber(strValue, typeCol.minimum, typeCol.maximum) : 0;
        newValue.valueStr = TaskDataRowCol.getTaskDataRowColUiValue(typeCol, newValue.valueStr, newValue.valueNbr);
        props.onChange(newValue);
    };

    render() {
        const props = this.props;
        const typeCol = props.taskTypeCol;
        const dataCol = props.taskDataRowCol;
        return (
            <FormField title={getFormFieldTitle(typeCol, props.showFieldName)} titleColor={getFormFieldTitleColor(props.showFieldName, props.showFieldNameColor)} required={typeCol.required && !props.isReadOnly} margin={FormFieldMargin}>
                {props.isReadOnly &&
                    <Typography>{dataCol?.valueStr}</Typography>
                }
                {!props.isReadOnly &&
                    <DisabledInputClickEnabler
                        input={<TextField
                            name={typeCol.field}
                            title={typeCol.title}
                            required={typeCol.required}
                            disabled={props.colIsReadOnly}
                            value={dataCol?.valueStr || ""}
                            InputProps={{
                                endAdornment: typeCol.unitTitle
                                    ? <InputAdornment position="end">{typeCol.unitTitle}</InputAdornment>
                                    : null
                            }}
                            inputProps={{ maxLength: typeCol.maxLength > 0 ? typeCol.maxLength : null }}
                            placeholder={typeCol.placeholder ? typeCol.placeholder : null}
                            autoComplete="off"
                            onChange={this.handleChange}
                            onBlur={this.handleBlur}
                            size="small"
                            fullWidth
                        />}
                        disabled={props.colIsReadOnly}
                    />
                }
            </FormField>
        );
    }
}